import BaseAPI from '../api'

export interface SearchAdvanceInterface {
    idDepartment?: number
    idFiscalYear?: number
    keywordLevel1?: string
    keywordLevel2?: string
    keywordLevel3?: string
    keywordLevel4?: string
    endDate?: string;
    startDate?: string;
}

export default class SearchApi extends BaseAPI {

    static getSearch(keyword: string): Promise<any> {
        return this.api.get(`search`, { params: keyword })
            .then((res) => res)
    }
    static getSearchAdvance(props:SearchAdvanceInterface): Promise<any> {
        return this.api.get(`advance-search`, { params: { ...props } })
            .then((res) => res)
    }
}